(function(angular){
	'use strict';

	angular
		.module('investorUpdatesModule')
		.directive('smoothHeightTransition', [
			'$timeout',
			smoothHeightTransitionFunction
		]);

	function smoothHeightTransitionFunction($timeout) {
		return {
			restrict: 'A',
			link: function($scope, $element, $attrs) {
				var element = $element[0];
				var setHeight;

				$scope.$watch(function() {
					return element.clientHeight;
				}, function(newHeight, oldHeight) {

					if(element.children.length === 1) {
						$element[0].parentElement.style.height = newHeight + 'px';
					}
				});
			}
		};
	}
})(window.angular);